function collectionWithTabs() {
  const tabsWidth = window.innerWidth;
  const cwts = document.querySelectorAll('.collections-with-tabs');

  cwts.forEach(cwt => {
    if (!cwt) return;

    const cwtNavigationItems = cwt.querySelectorAll('.tabs-navigation-item');
    const cwtNavigationSelect = cwt.querySelector('.tabs-navigation-select');
    const cwtList = cwt.querySelectorAll('.product-grid');

    const activateTab = (item) => {
      const tagid = item.dataset.tab || item.value;
      cwtNavigationItems.forEach(element => element.classList.remove('active'));
      cwtList.forEach(element => element.classList.remove('active'));
      item.classList.add('active');

      const tabElement = cwt.querySelector(`[data-tab-id="${tagid}"]`);
      if (tabElement) {
        tabElement.classList.add('active');
      }
    };

    // Faraxa: the tab list is used at every width (a swipeable ribbon on phones),
    // so wire the tabs up regardless of screen size, and only once per element.
    cwtNavigationItems.forEach(item => {
      if (item.dataset.tabsBound) return;
      item.dataset.tabsBound = '1';
      item.addEventListener('click', () => {
        activateTab(item);
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      item.addEventListener('keyup', (e) => { if (e.key === 'Enter' || e.key === ' ') activateTab(item); });
    });
    if (cwtNavigationSelect && !cwtNavigationSelect.dataset.tabsBound) {
      cwtNavigationSelect.dataset.tabsBound = '1';
      cwtNavigationSelect.addEventListener('change', () => activateTab(cwtNavigationSelect));
    }
  });
}

document.addEventListener('DOMContentLoaded', collectionWithTabs);
document.addEventListener('shopify:section:load', collectionWithTabs);
window.addEventListener('resize', collectionWithTabs);